export default __webpack_public_path__ + "static/media/floor-brush.bf0ca454.svg";